import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AddPhoneState, addPhoneFeatureKey } from './add-phone.reducer';

const getAddPhoneFeature = createFeatureSelector<AddPhoneState>(addPhoneFeatureKey);

export const getAddPhoneCallState = createSelector(getAddPhoneFeature, (state) => {
   return state.callState;
});
